// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__MQmea.styles_ocean-50__dz7wH {
  color: #e6f2ff;
}

.styles_color__MQmea.styles_ocean-100__lIKzY {
  color: #e6f2ff;
}

.styles_color__MQmea.styles_ocean-200__WVWM6 {
  color: #b3daff;
}

.styles_color__MQmea.styles_ocean-300__C4q7f {
  color: #7abfff;
}

.styles_color__MQmea.styles_ocean-400__NYBj- {
  color: #2392fb;
}

.styles_color__MQmea.styles_ocean-500__joyvX {
  color: #0074e0;
}

.styles_color__MQmea.styles_ocean-600__Z7ESE {
  color: #043571;
}

.styles_color__MQmea.styles_space-50__HTJ61 {
  color: #f0f0f0;
}

.styles_color__MQmea.styles_space-100__KoLuD {
  color: #e3e3e3;
}

.styles_color__MQmea.styles_space-200__5fsy8 {
  color: #bfbfbf;
}

.styles_color__MQmea.styles_space-300__\\+wLH- {
  color: gray;
}

.styles_color__MQmea.styles_space-400__-APTq {
  color: #616161;
}

.styles_color__MQmea.styles_space-500__blTw6 {
  color: #283439;
}

.styles_color__MQmea.styles_gray-50__jgepL {
  color: #eff3f6;
}

.styles_color__MQmea.styles_gray-100__8sVXn {
  color: #e6ecef;
}

.styles_color__MQmea.styles_gray-200__0XAgd {
  color: #cfd8de;
}

.styles_color__MQmea.styles_gray-300__BZRac {
  color: #a8b9c2;
}

.styles_color__MQmea.styles_gray-400__DGHkZ {
  color: #7e98a5;
}

.styles_color__MQmea.styles_gray-500__SfBcH {
  color: #738f9c;
}

.styles_color__MQmea.styles_green-50__CLl3Z {
  color: #e3fdf6;
}

.styles_color__MQmea.styles_green-100__70k0C {
  color: #c5f6ea;
}

.styles_color__MQmea.styles_green-200__8Gss2 {
  color: #69ddc2;
}

.styles_color__MQmea.styles_green-300__2c5KA {
  color: #45bfa3;
}

.styles_color__MQmea.styles_green-400__q4N37 {
  color: #1cab8a;
}

.styles_color__MQmea.styles_green-500__5Qtx2 {
  color: #128268;
}

.styles_color__MQmea.styles_red-50__ln0i2 {
  color: #fff0f3;
}

.styles_color__MQmea.styles_red-100__0x1S1 {
  color: #f9d2db;
}

.styles_color__MQmea.styles_red-200__8oqH- {
  color: #f8b4c4;
}

.styles_color__MQmea.styles_red-300__GMRok {
  color: #e85e81;
}

.styles_color__MQmea.styles_red-400__PRotl {
  color: #e23661;
}

.styles_color__MQmea.styles_red-500__sG58H {
  color: #b82348;
}

.styles_color__MQmea.styles_yellow-50__oET1t {
  color: #fffae6;
}

.styles_color__MQmea.styles_yellow-100__r9FB9 {
  color: #fff0b3;
}

.styles_color__MQmea.styles_yellow-200__unOaf {
  color: #ffe380;
}

.styles_color__MQmea.styles_yellow-300__X0SK6 {
  color: #ffcf57;
}

.styles_color__MQmea.styles_yellow-400__ienZx {
  color: #ffc60a;
}

.styles_color__MQmea.styles_yellow-500__Y7J5i {
  color: #ffb700;
}

.styles_color__MQmea.styles_orange-50__ZYwA3 {
  color: #fff2eb;
}

.styles_color__MQmea.styles_orange-100__liGUl {
  color: #ffe4d6;
}

.styles_color__MQmea.styles_orange-200__jpDra {
  color: #ffc69e;
}

.styles_color__MQmea.styles_orange-300__Erxdt {
  color: #ffa047;
}

.styles_color__MQmea.styles_orange-400__2HBoV {
  color: #ff7b42;
}

.styles_color__MQmea.styles_orange-500__dbZ8q {
  color: #ee4920;
}

.styles_color__MQmea.styles_turquoise-50__l8Erd {
  color: transparent;
}

.styles_color__MQmea.styles_turquoise-100__ZOErA {
  color: #e6fcff;
}

.styles_color__MQmea.styles_turquoise-200__Yqssv {
  color: #b3f5ff;
}

.styles_color__MQmea.styles_turquoise-300__FCIeq {
  color: #78e2f2;
}

.styles_color__MQmea.styles_turquoise-400__cJg06 {
  color: #00c7e6;
}

.styles_color__MQmea.styles_turquoise-500__RUTii {
  color: transparent;
}

.styles_color__MQmea.styles_turquoise-600__Al4oK {
  color: transparent;
}

.styles_color__MQmea.styles_violet-50__9nhnk {
  color: #eae6ff;
}

.styles_color__MQmea.styles_violet-100__uqpKh {
  color: #d9d1ff;
}

.styles_color__MQmea.styles_violet-200__1fv69 {
  color: #bfb3ff;
}

.styles_color__MQmea.styles_violet-300__BefeU {
  color: #9d90ea;
}

.styles_color__MQmea.styles_violet-400__KvQni {
  color: #8678d9;
}

.styles_color__MQmea.styles_violet-500__0qP2g {
  color: #6f5ccc;
}

.styles_color__MQmea.styles_snow-50__GDtJu {
  color: white;
}

.styles_color__MQmea.styles_snow-100__8MI\\+c {
  color: #f7f7f7;
}

.styles_color__MQmea.styles_snow-200__bnPQc {
  color: #f0efef;
}

.styles_color__MQmea.styles_snow-300__QdO\\+X {
  color: #e6e6e6;
}

.styles_color__MQmea.styles_snow-400__GyioO {
  color: #e1e0e0;
}

.styles_color__MQmea.styles_snow-500__0j7NW {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__hfMcp.styles_ocean__PCZSL {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__hfMcp.styles_ocean-light__7gN6Q {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__hfMcp.styles_green__BY1kW {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__hfMcp.styles_green-light__SI8fx {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__hfMcp.styles_red__xrmA8 {
  background-color: #e23661;
  color: white;
}

.styles_background-color__hfMcp.styles_red-light__ULfN2 {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__hfMcp.styles_orange__tE3I2 {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__hfMcp.styles_orange-light__f82cX {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__hfMcp.styles_space__iGnHB {
  background-color: #616161;
  color: white;
}

.styles_background-color__hfMcp.styles_space-light__x5YAT {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__hfMcp.styles_gray-light__fdTSN {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__hfMcp.styles_violet__2Hroc {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__hfMcp.styles_violet-light__UxeB2 {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__hfMcp.styles_yellow__hTjRP {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__hfMcp.styles_yellow-light__nM1pv {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__rftfq {
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  border: 1px solid #eff3f6;
  border-radius: 50%;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.styles_root__rftfq .styles_status__g3tWQ {
  background-color: #a8b9c2;
  border: 2px solid white;
  border-radius: 50%;
  bottom: 0;
  height: 14px;
  position: absolute;
  right: 0;
  width: 14px;
  z-index: 10;
}
.styles_root__rftfq .styles_status__g3tWQ.styles_online__btapR {
  background-color: #1cab8a;
}
.styles_root__rftfq .styles_labelWrapper__bsJwH {
  color: white;
}
.styles_root__rftfq .styles_childrenWrapper__gqD5E,
.styles_root__rftfq .styles_childrenWrapper__gqD5E > *,
.styles_root__rftfq .styles_labelWrapper__bsJwH {
  height: 100%;
  width: 100%;
}
.styles_root__rftfq.styles_ocean__PCZSL {
  background-color: #7abfff;
  border-color: #2392fb;
}
.styles_root__rftfq.styles_ocean__PCZSL .styles_labelWrapper__bsJwH {
  color: white;
}
.styles_root__rftfq.styles_space__iGnHB {
  background-color: gray;
  border-color: #616161;
}
.styles_root__rftfq.styles_space__iGnHB .styles_labelWrapper__bsJwH {
  color: white;
}
.styles_root__rftfq.styles_gray__CN5o- {
  background-color: #a8b9c2;
  border-color: #7e98a5;
}
.styles_root__rftfq.styles_gray__CN5o- .styles_labelWrapper__bsJwH {
  color: #eff3f6;
}
.styles_root__rftfq.styles_green__BY1kW {
  background-color: #45bfa3;
  border-color: #1cab8a;
}
.styles_root__rftfq.styles_green__BY1kW .styles_labelWrapper__bsJwH {
  color: #e3fdf6;
}
.styles_root__rftfq.styles_red__xrmA8 {
  background-color: #e85e81;
  border-color: #e23661;
}
.styles_root__rftfq.styles_red__xrmA8 .styles_labelWrapper__bsJwH {
  color: #fff0f3;
}
.styles_root__rftfq.styles_yellow__hTjRP {
  background-color: #ffc60a;
  border-color: #ffb700;
}
.styles_root__rftfq.styles_yellow__hTjRP .styles_labelWrapper__bsJwH {
  color: #fffae6;
}
.styles_root__rftfq.styles_orange__tE3I2 {
  background-color: #ffa047;
  border-color: #ff7b42;
}
.styles_root__rftfq.styles_orange__tE3I2 .styles_labelWrapper__bsJwH {
  color: #fff2eb;
}
.styles_root__rftfq.styles_turquoise__bV5AJ {
  background-color: #9d90ea;
  border-color: #8678d9;
}
.styles_root__rftfq.styles_turquoise__bV5AJ .styles_labelWrapper__bsJwH {
  color: #e6fcff;
}
.styles_root__rftfq.styles_violet__2Hroc {
  background-color: #9d90ea;
  border-color: #8678d9;
}
.styles_root__rftfq.styles_violet__2Hroc .styles_labelWrapper__bsJwH {
  color: #eae6ff;
}
.styles_root__rftfq.styles_snow__zQEA6 {
  background-color: #f0efef;
  border-color: #a8b9c2;
}
.styles_root__rftfq.styles_snow__zQEA6 .styles_labelWrapper__bsJwH {
  color: #a8b9c2;
}
.styles_root__rftfq.styles_oceanLight__ZV10d {
  background-color: #e6f2ff;
  border-color: #b3daff;
}
.styles_root__rftfq.styles_oceanLight__ZV10d .styles_labelWrapper__bsJwH {
  color: #2392fb;
}
.styles_root__rftfq.styles_redLight__KaI6v {
  background-color: #f9d2db;
  border-color: #f8b4c4;
}
.styles_root__rftfq.styles_redLight__KaI6v .styles_labelWrapper__bsJwH {
  color: #e23661;
}
.styles_root__rftfq.styles_orangeLight__rcxYe {
  background-color: #ffe4d6;
  border-color: #ffc69e;
}
.styles_root__rftfq.styles_orangeLight__rcxYe .styles_labelWrapper__bsJwH {
  color: #ff7b42;
}
.styles_root__rftfq.styles_tempGray__xIpWO {
  background-color: #e6ecef;
  border-color: #e6ecef;
}
.styles_root__rftfq.styles_tempGray__xIpWO .styles_labelWrapper__bsJwH {
  color: #738f9c;
}
.styles_root__rftfq.styles_clickable__lG-BG {
  cursor: pointer;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_ocean__PCZSL {
  background-color: #2392fb;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_space__iGnHB {
  background-color: #616161;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_gray__CN5o- {
  background-color: #7e98a5;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_green__BY1kW {
  background-color: #1cab8a;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_red__xrmA8 {
  background-color: #b82348;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_yellow__hTjRP {
  background-color: #ffb700;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_orange__tE3I2 {
  background-color: #ff7b42;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_turquoise__bV5AJ {
  background-color: #8678d9;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_violet__2Hroc {
  background-color: #8678d9;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_snow__zQEA6 {
  background-color: #cfcfcf;
  border-color: white;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_snow__zQEA6 .styles_labelWrapper__bsJwH {
  color: white;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_oceanLight__ZV10d {
  background-color: #b3daff;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_redLight__KaI6v {
  background-color: #f8b4c4;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_orangeLight__rcxYe {
  background-color: #ffc69e;
}
.styles_root__rftfq.styles_clickable__lG-BG:hover.styles_tempGray__xIpWO {
  background-color: #cfd8de;
}
.styles_root__rftfq.styles_sm__2Lf0v {
  font-size: 1rem;
  height: 32px;
  width: 32px;
}
.styles_root__rftfq.styles_md__0yFyM {
  font-size: 1rem;
  height: 40px;
  width: 40px;
}
.styles_root__rftfq.styles_lg__DydHz {
  font-size: 1.7142857143rem;
  height: 60px;
  width: 60px;
}
.styles_root__rftfq.styles_xl__ccl0p {
  font-size: 2.7142857143rem;
  height: 96px;
  width: 96px;
}
.styles_root__rftfq.styles_fill__KFn\\+E {
  font-size: inherit;
  height: 100%;
  width: 100%;
}
.styles_root__rftfq .styles_childrenWrapper__gqD5E {
  color: #283439;
}
.styles_root__rftfq .styles_image__qkEFl {
  border-radius: 50%;
  color: transparent;
  height: 100%;
  object-fit: cover;
  width: 100%;
}
.styles_root__rftfq .styles_badge__9iM3M {
  position: absolute;
  right: -1px;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/avatar/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EEkDI,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFArB,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AA6UJ;AA3UI;EACI,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AA6UR;AA3UQ;EACI,yBAAA;AA6UZ;AAzUI;EACI,YAAA;AA2UR;AAxUI;;;EAGI,YAAA;EACA,WAAA;AA0UR;AAvUI;EACI,yBAAA;EACA,qBAAA;AAyUR;AAvUQ;EACI,YAAA;AAyUZ;AArUI;EACI,sBAAA;EACA,qBAAA;AAuUR;AArUQ;EACI,YAAA;AAuUZ;AAnUI;EACI,yBAAA;EACA,qBAAA;AAqUR;AAnUQ;EACI,cAAA;AAqUZ;AAjUI;EACI,yBAAA;EACA,qBAAA;AAmUR;AAjUQ;EACI,cAAA;AAmUZ;AA/TI;EACI,yBAAA;EACA,qBAAA;AAiUR;AA/TQ;EACI,cAAA;AAiUZ;AA7TI;EACI,yBAAA;EACA,qBAAA;AA+TR;AA7TQ;EACI,cAAA;AA+TZ;AA3TI;EACI,yBAAA;EACA,qBAAA;AA6TR;AA3TQ;EACI,cAAA;AA6TZ;AAzTI;EACI,yBAAA;EACA,qBAAA;AA2TR;AAzTQ;EACI,cAAA;AA2TZ;AAvTI;EACI,yBAAA;EACA,qBAAA;AAyTR;AAvTQ;EACI,cAAA;AAyTZ;AArTI;EACI,yBAAA;EACA,qBAAA;AAuTR;AArTQ;EACI,cAAA;AAuTZ;AAnTI;EACI,yBAAA;EACA,qBAAA;AAqTR;AAnTQ;EACI,cAAA;AAqTZ;AAjTI;EACI,yBAAA;EACA,qBAAA;AAmTR;AAjTQ;EACI,cAAA;AAmTZ;AA/SI;EACI,yBAAA;EACA,qBAAA;AAiTR;AA/SQ;EACI,cAAA;AAiTZ;AA5SI;EACI,yBAAA;EACA,qBAAA;AA8SR;AA5SQ;EACI,cAAA;AA8SZ;AA1SI;EACI,eAAA;AA4SR;AAxSQ;EACI,yBAAA;AA0SZ;AAvSQ;EACI,yBAAA;AAySZ;AAtSQ;EACI,yBAAA;AAwSZ;AArSQ;EACI,yBAAA;AAuSZ;AApSQ;EACI,yBAAA;AAsSZ;AAnSQ;EACI,yBAAA;AAqSZ;AAlSQ;EACI,yBAAA;AAoSZ;AAjSQ;EACI,yBAAA;AAmSZ;AAhSQ;EACI,yBAAA;AAkSZ;AA/RQ;EACI,yBAAA;EACA,mBAAA;AAiSZ;AA/RY;EACI,YAAA;AAiShB;AA7RQ;EACI,yBAAA;AA+RZ;AA5RQ;EACI,yBAAA;AA8RZ;AA3RQ;EACI,yBAAA;AA6RZ;AAzRQ;EACI,yBAAA;AA2RZ;AAvRI;EACI,eAAA;EACA,YAAA;EACA,WAAA;AAyRR;AAtRI;EACI,eAAA;EACA,YAAA;EACA,WAAA;AAwRR;AArRI;EACI,0BAAA;EACA,YAAA;EACA,WAAA;AAuRR;AApRI;EACI,0BAAA;EACA,YAAA;EACA,WAAA;AAsRR;AAnRI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AAqRR;AAlRI;EACI,cAAA;AAoRR;AAjRI;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AAmRR;AAhRI;EACI,kBAAA;EACA,WAAA;EACA,MAAA;AAkRR","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    @include theme.typo(body2);\n\n    border: 1px solid theme.color(gray-50);\n    border-radius: theme.get-border-radius(rounded);\n    box-sizing: border-box;\n    flex-shrink: 0;\n    position: relative;\n    user-select: none;\n\n    .status {\n        background-color: theme.color(gray-300);\n        border: 2px solid theme.color(snow-50);\n        border-radius: theme.get-border-radius(rounded);\n        bottom: 0;\n        height: 14px;\n        position: absolute;\n        right: 0;\n        width: 14px;\n        z-index: 10;\n\n        &.online {\n            background-color: theme.color(green-400);\n        }\n    }\n\n    .labelWrapper {\n        color: theme.color(snow-50);\n    }\n\n    .childrenWrapper,\n    .childrenWrapper > *,\n    .labelWrapper {\n        height: 100%;\n        width: 100%;\n    }\n\n    &.ocean {\n        background-color: theme.color(ocean-300);\n        border-color: theme.color(ocean-400);\n\n        .labelWrapper {\n            color: theme.color(snow-50);\n        }\n    }\n\n    &.space {\n        background-color: theme.color(space-300);\n        border-color: theme.color(space-400);\n\n        .labelWrapper {\n            color: theme.color(snow-50);\n        }\n    }\n\n    &.gray {\n        background-color: theme.color(gray-300);\n        border-color: theme.color(gray-400);\n\n        .labelWrapper {\n            color: theme.color(gray-50);\n        }\n    }\n\n    &.green {\n        background-color: theme.color(green-300);\n        border-color: theme.color(green-400);\n\n        .labelWrapper {\n            color: theme.color(green-50);\n        }\n    }\n\n    &.red {\n        background-color: theme.color(red-300);\n        border-color: theme.color(red-400);\n\n        .labelWrapper {\n            color: theme.color(red-50);\n        }\n    }\n\n    &.yellow {\n        background-color: theme.color(yellow-400);\n        border-color: theme.color(yellow-500);\n\n        .labelWrapper {\n            color: theme.color(yellow-50);\n        }\n    }\n\n    &.orange {\n        background-color: theme.color(orange-300);\n        border-color: theme.color(orange-400);\n\n        .labelWrapper {\n            color: theme.color(orange-50);\n        }\n    }\n\n    &.turquoise {\n        background-color: theme.color(violet-300);\n        border-color: theme.color(violet-400);\n\n        .labelWrapper {\n            color: theme.color(turquoise-100);\n        }\n    }\n\n    &.violet {\n        background-color: theme.color(violet-300);\n        border-color: theme.color(violet-400);\n\n        .labelWrapper {\n            color: theme.color(violet-50);\n        }\n    }\n\n    &.snow {\n        background-color: theme.color(snow-200);\n        border-color: theme.color(gray-300);\n\n        .labelWrapper {\n            color: theme.color(gray-300);\n        }\n    }\n\n    &.oceanLight {\n        background-color: theme.color(ocean-100);\n        border-color: theme.color(ocean-200);\n\n        .labelWrapper {\n            color: theme.color(ocean-400);\n        }\n    }\n\n    &.redLight {\n        background-color: theme.color(red-100);\n        border-color: theme.color(red-200);\n\n        .labelWrapper {\n            color: theme.color(red-400);\n        }\n    }\n\n    &.orangeLight {\n        background-color: theme.color(orange-100);\n        border-color: theme.color(orange-200);\n\n        .labelWrapper {\n            color: theme.color(orange-400);\n        }\n    }\n\n    // TODO: get rid of this when its usage is replaced\n    &.tempGray {\n        background-color: theme.color(gray-100);\n        border-color: theme.color(gray-100);\n\n        .labelWrapper {\n            color: theme.color(gray-500);\n        }\n    }\n\n    &.clickable {\n        cursor: pointer;\n    }\n\n    &.clickable:hover {\n        &.ocean {\n            background-color: theme.color(ocean-400);\n        }\n\n        &.space {\n            background-color: theme.color(space-400);\n        }\n\n        &.gray {\n            background-color: theme.color(gray-400);\n        }\n\n        &.green {\n            background-color: theme.color(green-400);\n        }\n\n        &.red {\n            background-color: theme.color(red-500);\n        }\n\n        &.yellow {\n            background-color: theme.color(yellow-500);\n        }\n\n        &.orange {\n            background-color: theme.color(orange-400);\n        }\n\n        &.turquoise {\n            background-color: theme.color(violet-400);\n        }\n\n        &.violet {\n            background-color: theme.color(violet-400);\n        }\n\n        &.snow {\n            background-color: theme.color(snow-500);\n            border-color: theme.color(snow-50);\n\n            .labelWrapper {\n                color: theme.color(snow-50);\n            }\n        }\n\n        &.oceanLight {\n            background-color: theme.color(ocean-200);\n        }\n\n        &.redLight {\n            background-color: theme.color(red-200);\n        }\n\n        &.orangeLight {\n            background-color: theme.color(orange-200);\n        }\n\n        // TODO: get rid of this when its usage is replaced\n        &.tempGray {\n            background-color: theme.color(gray-200);\n        }\n    }\n\n    &.sm {\n        font-size: theme.px2rem(14px);\n        height: 32px;\n        width: 32px;\n    }\n\n    &.md {\n        font-size: theme.px2rem(14px);\n        height: 40px;\n        width: 40px;\n    }\n\n    &.lg {\n        font-size: theme.px2rem(24px);\n        height: 60px;\n        width: 60px;\n    }\n\n    &.xl {\n        font-size: theme.px2rem(38px);\n        height: 96px;\n        width: 96px;\n    }\n\n    &.fill {\n        font-size: inherit;\n        height: 100%;\n        width: 100%;\n    }\n\n    .childrenWrapper {\n        color: theme.color(space-500);\n    }\n\n    .image {\n        border-radius: theme.get-border-radius(rounded);\n        color: transparent;\n        height: 100%;\n        object-fit: cover;\n        width: 100%;\n    }\n\n    .badge {\n        position: absolute;\n        right: -1px;\n        top: 0;\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__MQmea`,
	"ocean-50": `styles_ocean-50__dz7wH`,
	"ocean-100": `styles_ocean-100__lIKzY`,
	"ocean-200": `styles_ocean-200__WVWM6`,
	"ocean-300": `styles_ocean-300__C4q7f`,
	"ocean-400": `styles_ocean-400__NYBj-`,
	"ocean-500": `styles_ocean-500__joyvX`,
	"ocean-600": `styles_ocean-600__Z7ESE`,
	"space-50": `styles_space-50__HTJ61`,
	"space-100": `styles_space-100__KoLuD`,
	"space-200": `styles_space-200__5fsy8`,
	"space-300": `styles_space-300__+wLH-`,
	"space-400": `styles_space-400__-APTq`,
	"space-500": `styles_space-500__blTw6`,
	"gray-50": `styles_gray-50__jgepL`,
	"gray-100": `styles_gray-100__8sVXn`,
	"gray-200": `styles_gray-200__0XAgd`,
	"gray-300": `styles_gray-300__BZRac`,
	"gray-400": `styles_gray-400__DGHkZ`,
	"gray-500": `styles_gray-500__SfBcH`,
	"green-50": `styles_green-50__CLl3Z`,
	"green-100": `styles_green-100__70k0C`,
	"green-200": `styles_green-200__8Gss2`,
	"green-300": `styles_green-300__2c5KA`,
	"green-400": `styles_green-400__q4N37`,
	"green-500": `styles_green-500__5Qtx2`,
	"red-50": `styles_red-50__ln0i2`,
	"red-100": `styles_red-100__0x1S1`,
	"red-200": `styles_red-200__8oqH-`,
	"red-300": `styles_red-300__GMRok`,
	"red-400": `styles_red-400__PRotl`,
	"red-500": `styles_red-500__sG58H`,
	"yellow-50": `styles_yellow-50__oET1t`,
	"yellow-100": `styles_yellow-100__r9FB9`,
	"yellow-200": `styles_yellow-200__unOaf`,
	"yellow-300": `styles_yellow-300__X0SK6`,
	"yellow-400": `styles_yellow-400__ienZx`,
	"yellow-500": `styles_yellow-500__Y7J5i`,
	"orange-50": `styles_orange-50__ZYwA3`,
	"orange-100": `styles_orange-100__liGUl`,
	"orange-200": `styles_orange-200__jpDra`,
	"orange-300": `styles_orange-300__Erxdt`,
	"orange-400": `styles_orange-400__2HBoV`,
	"orange-500": `styles_orange-500__dbZ8q`,
	"turquoise-50": `styles_turquoise-50__l8Erd`,
	"turquoise-100": `styles_turquoise-100__ZOErA`,
	"turquoise-200": `styles_turquoise-200__Yqssv`,
	"turquoise-300": `styles_turquoise-300__FCIeq`,
	"turquoise-400": `styles_turquoise-400__cJg06`,
	"turquoise-500": `styles_turquoise-500__RUTii`,
	"turquoise-600": `styles_turquoise-600__Al4oK`,
	"violet-50": `styles_violet-50__9nhnk`,
	"violet-100": `styles_violet-100__uqpKh`,
	"violet-200": `styles_violet-200__1fv69`,
	"violet-300": `styles_violet-300__BefeU`,
	"violet-400": `styles_violet-400__KvQni`,
	"violet-500": `styles_violet-500__0qP2g`,
	"snow-50": `styles_snow-50__GDtJu`,
	"snow-100": `styles_snow-100__8MI+c`,
	"snow-200": `styles_snow-200__bnPQc`,
	"snow-300": `styles_snow-300__QdO+X`,
	"snow-400": `styles_snow-400__GyioO`,
	"snow-500": `styles_snow-500__0j7NW`,
	"background-color": `styles_background-color__hfMcp`,
	"ocean": `styles_ocean__PCZSL`,
	"ocean-light": `styles_ocean-light__7gN6Q`,
	"green": `styles_green__BY1kW`,
	"green-light": `styles_green-light__SI8fx`,
	"red": `styles_red__xrmA8`,
	"red-light": `styles_red-light__ULfN2`,
	"orange": `styles_orange__tE3I2`,
	"orange-light": `styles_orange-light__f82cX`,
	"space": `styles_space__iGnHB`,
	"space-light": `styles_space-light__x5YAT`,
	"gray-light": `styles_gray-light__fdTSN`,
	"violet": `styles_violet__2Hroc`,
	"violet-light": `styles_violet-light__UxeB2`,
	"yellow": `styles_yellow__hTjRP`,
	"yellow-light": `styles_yellow-light__nM1pv`,
	"root": `styles_root__rftfq`,
	"status": `styles_status__g3tWQ`,
	"online": `styles_online__btapR`,
	"labelWrapper": `styles_labelWrapper__bsJwH`,
	"childrenWrapper": `styles_childrenWrapper__gqD5E`,
	"gray": `styles_gray__CN5o-`,
	"turquoise": `styles_turquoise__bV5AJ`,
	"snow": `styles_snow__zQEA6`,
	"oceanLight": `styles_oceanLight__ZV10d`,
	"redLight": `styles_redLight__KaI6v`,
	"orangeLight": `styles_orangeLight__rcxYe`,
	"tempGray": `styles_tempGray__xIpWO`,
	"clickable": `styles_clickable__lG-BG`,
	"sm": `styles_sm__2Lf0v`,
	"md": `styles_md__0yFyM`,
	"lg": `styles_lg__DydHz`,
	"xl": `styles_xl__ccl0p`,
	"fill": `styles_fill__KFn+E`,
	"image": `styles_image__qkEFl`,
	"badge": `styles_badge__9iM3M`
};
export default ___CSS_LOADER_EXPORT___;
